import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Comment }  from '../models/comment';
import { Observable, Subject } from 'rxjs/Rx';
import 'rxjs/add/operator/map'

@Injectable()
export class CommentService {

  constructor(private http: Http) { }

  // -----------------------------
  // Current comment
  // -----------------------------

  public currentCommentResponseValue: any;

  // the currently loaded comment object
  private currentCommentResponse = new Subject<any>();

  // observable comment
  public currentCommentResponse$ = this.currentCommentResponse.asObservable();

  // for updating the currently loaded comment
  updateCurrentCommentResponse(comment: any) {
    this.currentCommentResponseValue = comment;
    this.currentCommentResponse.next(comment);
  }

  createComment(comment:Comment) {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify(comment);
    return this.http.post(environment.api + 'submission', body, options ).map((res: Response) => res.json());
  }
}


// WEBPACK FOOTER //
// ./src/app/services/comment.service.ts